<template>
  <el-form :model="formFac" ref="formFac" :label-position="'left'">
    <label class="mb-4 fw-bolder">Selecciona el tipo de comprobante que deseas recibir</label>
    <div class="row">
      <div class="col-sm-3">
        <label>Turista</label>
      </div>
      <div class="col-sm-9">
        <el-form-item class="mb-4" prop="turista" :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur'] }]">
          <el-radio-group v-model="formFac.turista" size="medium">
            <el-radio-button label="N">Nacional</el-radio-button>
            <el-radio-button label="E">Extranjero</el-radio-button>
          </el-radio-group>
        </el-form-item>

      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <label>Comprobante</label>
      </div>
      <div class="col-sm-9">
        <el-form-item class="mb-4" prop="fndoc" :rules="[
          { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
          { validator: validarLongitud, trigger: 'blur' }
        ]">
          <el-input :placeholder="placeHolder.voucher" v-model="formFac.fndoc" class="input-with-select w-100"
            size="medium" :clearable="true" :maxlength="maxlength" @input="sanitizeInput('fndoc')" @blur="handleBlur">
            <el-select v-model="formFac.voucher" slot="prepend" placeholder="Seleccione" @change="changeTpodocument">
              <el-option key="03" label="Boleta" value="03"></el-option>
              <el-option key="01" label="Factura" value="01"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <label>{{ placeHolder.namebussines }}</label>
      </div>
      <div class="col-sm-9">
        <el-form-item prop="fname" size="medium" :rules="[
          { required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur'] }
        ]">
          <el-input v-model="formFac.fname" :placeholder="placeHolder.namebussines"></el-input>
        </el-form-item>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <label>Celular</label>
      </div>
      <div class="col-sm-9">
        <el-form-item prop="fphone" :rules="[
          { required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur'] },
          { pattern: /^[0-9]+$/, message: 'Solo números', trigger: ['blur', 'change'] },
        ]">
          <el-input v-model.number="formFac.fphone" placeholder="N° de celular" maxlength="9" size="medium"
            @input="sanitizeInput('fphone')"></el-input>
        </el-form-item>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <label>Email</label>
      </div>
      <div class="col-sm-9">
        <el-form-item prop="femail" :rules="[
          { required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur'] },
          { type: 'email', message: 'Ingrese una dirección de correo electrónico correcta', trigger: ['blur', 'change'] }
        ]">
          <el-input v-model="formFac.femail" placeholder="Correo electrónico" size="medium"></el-input>
        </el-form-item>
      </div>
    </div>

    <hr>
    <el-form-item prop="terms" :rules="[
      { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
    ]">
      <el-checkbox v-model="formFac.terms">
        He leído y acepto los
        <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y
            Condiciones</b></a></el-checkbox>
    </el-form-item>

    <div class="text-right">
      <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">Atras</button>
      <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formFac')">Siguiente</button>
    </div>

  </el-form>
</template>

<script>
import services from "@/services/services.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
  props: {
    abonado: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data: () => ({
    formFac: {
      turista: 'N',
      fndoc: '',
      fname: '',
      fphone: '',
      femail: '',
      voucher: '03',
      terms: null
    },
    maxlength: 8,
    placeHolder: {
      voucher: 'DNI',
      namebussines: 'Nombres'
    }

  }),
  methods: {
    validarLongitud(rule, value, callback) {
      if (!value) {
        callback(); // No mostrar error si el campo está vacío (lo maneja la regla `required`)
      } else if (value.length !== this.maxlength) {
        callback(new Error(`Debe contener exactamente ${this.maxlength} caracteres.`));
      } else {
        callback();
      }
    },
    sanitizeInput(field) {
      this.formFac[field] = this.formFac[field].replace(/\D/g, ''); // Elimina todo lo que no sea número
    },
    changeTpodocument() {
      this.formFac.fndoc = '';
      this.formFac.fname = '';
      this.maxlength = (this.formFac.voucher == '03') ? 8 : 11;
      this.placeHolder.voucher = (this.formFac.voucher == '03') ? 'Ingrese DNI' : 'RUC';
      this.placeHolder.namebussines = (this.formFac.voucher == '03') ? 'Nombres' : 'Razon social';
    },
    volver() {
      this.$emit("resVolver", 2)
    },
    async handleBlur() {
      let tempo = this.formFac.fndoc;
      this.formFac.fname = '';

      if (this.formFac.fndoc !== '' && tempo.length === this.maxlength) {
        let target = (this.formFac.voucher === '03') ? 'v1/consultaDni' : 'v1/consultaRuc';
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

        await services.getReniecSunat(target, this.formFac.fndoc)
          .then(res => {
            //this.loader = false;
            if (res.data) {
              if (this.formFac.voucher === '03') {
                this.formFac.fname = `${res.data.prenombres} ${res.data.apPrimer} ${res.data.apSegundo}`;
              } else {
                this.formFac.fname = res.data.ddp_nombre;
              }
            }
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          })
          .catch(error => {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            //console.error("Error en la consulta:", error);
          });
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)
          return false

        this.$emit("resFact", this.formFac)
      })
    }
  },
  created() {

    this.formFac.fndoc = this.abonado.ndocument
    this.formFac.fname = this.abonado.firstname
    this.formFac.fphone = this.abonado.phone1
    this.formFac.femail = this.abonado.email

  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/abonados/Facturacion.vue